export const formationsBaseUrl = '/formations';
export const articlesBaseUrl = '/articles';
export const videosBaseUrl = '/videos';